import { useMemo } from "react";
import { EditableCard } from "../../../components/editableCard.component";
import { PatientList } from "../../patient/patientList.component";
import { AppRouteApi, AppRouteUi } from "../../../config/appRoute";
import { useParams } from "react-router";
import {
  IPaginationSearchFilter,
  useTablePaginationSearchFilter,
} from "../../../hooks";
import { ActionsPatientTable, useAppSelector } from "../../../core/redux";
import { ApiSchemaFilteredPatient } from "../../../models/api";

export const CompanyPatientList = () => {
  const { companyId } = useParams<{ companyId: string }>();
  const { pageNumber, pageSize, nextPageToken, isLoading } = useAppSelector(
    (state) => state.patientTable
  );
  const apiParams = useMemo<IPaginationSearchFilter["customParams"]>(() => {
    return {
      NextPageToken: nextPageToken,
      PageSize: pageSize,
      PageNumber: pageNumber,
      CompanyId: companyId,
    };
  }, [nextPageToken, pageSize, pageNumber, companyId]);
  const { apiData } = useTablePaginationSearchFilter<
    ApiSchemaFilteredPatient,
    typeof ActionsPatientTable
  >(ActionsPatientTable, {
    customParams: apiParams,
    apiRoute: AppRouteApi.Patient.Root(),
  });

  return (
    <EditableCard
      link={`${AppRouteUi.Company.Root()}/update/${companyId}`}
      title="Patient List"
      isValidating={isLoading}
    >
      <PatientList
        data={apiData?.list}
        totalCount={apiData?.totalCount || 0}
        isValidating={isLoading}
        isInProfile
      />
    </EditableCard>
  );
};
